import CustomButton from '../reusable/CustomButton';
import CustomModal from '../reusable/CustomModal';

interface ConfigurationInvalidValuesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConfigurationInvalidValuesModal = ({ isOpen, onClose }: ConfigurationInvalidValuesModalProps) => (
  <CustomModal title="Update invalid values" isOpen={isOpen} handleClose={onClose} icon={false} maxWidth="xs">
    <p className="eoa-configuration-invalid-values-message">
      Some fields have values that aren&apos;t valid. Please correct them before leaving this page.
    </p>
    <div className="custom-modal-actions-container">
      <CustomButton variant="primary" size="medium" buttonText="Continue editing" buttonAction={onClose} />
    </div>
  </CustomModal>
);

export default ConfigurationInvalidValuesModal;
